import { useSearch } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import {
  COURSES_PATH,
  SUPPORT_PATH,
  GROUPS_PATH,
  SIMULATORS_PATH,
  HOME_START_PATH,
  USERS_PATH,
} from "../routes";

type MenuItem = {
  label: string;
  to: string;
  search?: { category?: number };
  onClick?: () => void;
};

function useMenuItems() {
  const { t } = useTranslation();
  // Present on the courses, course and lesson pages; keeps the selected
  // category tab when navigating back to the courses page via the menu.
  const { category } = useSearch({ strict: false });
  const items: MenuItem[] = [
    {
      label: t("common.menu.home"),
      to: HOME_START_PATH,
    },
    {
      label: t("common.menu.schoolClasses"),
      to: GROUPS_PATH,
    },
    {
      label: t("common.menu.users"),
      to: USERS_PATH,
    },
    {
      label: t("common.menu.courses"),
      to: COURSES_PATH,
      search: { category },
    },
    {
      label: t("common.menu.simulators"),
      to: SIMULATORS_PATH,
    },
    {
      label: t("common.menu.support"),
      to: SUPPORT_PATH,
    },
  ];
  return items;
}

export default useMenuItems;
